var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgLocationGreen = function SvgLocationGreen(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none",
    viewBox: "0 0 14 18"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#0F4C3A",
    d: "M7 17.125C10.125 12.75 12.625 9 12.625 6.5a5.625 5.625 0 1 0-11.25 0c0 2.5 2.5 6.25 5.625 10.625Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#0F4C3A",
    d: "M9.5 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
  })));
};
export default SvgLocationGreen;